export default "__VITE_ASSET__8mohqE3o__"